import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HotelManagementService, HotelManagementProperties } from '../services/hotelManagement.service';
import {faExclamationTriangle, faXmarkCircle} from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-hotel-management',
  templateUrl: './hotel-management.component.html',
  styleUrls: ['./hotel-management.component.css']
})
export class HotelManagementComponent implements OnInit {
  hotels: HotelManagementProperties[] = [];
  filteredHotels: HotelManagementProperties[] = [];
  faExclamation = faExclamationTriangle;
  faXCircle = faXmarkCircle;
  // Form
  showForm = false;
  editMode = false;
  hotelForm: FormGroup;

  // Filters
  typeFilter = 'all';
  cityFilter = 'all';
  searchTerm = '';

  // UI
  loading = false;
  submitted = false;
  successMsg: string | null = null;
  error: string | null = null;

  // Delete modal
  showDeleteModal = false;
  hotelToDelete: HotelManagementProperties | null = null;

  cities = ['Makkah', 'Madinah'];
  hotelTypes = ['Makkah', 'Madinah'];

  constructor(private hotelService: HotelManagementService, private fb: FormBuilder) {
    this.hotelForm = this.fb.group({
      id: [0],
      hotelId: [0],
      hotelName: ['', Validators.required],
      hotelType: ['', Validators.required],
      hotelCity: ['', Validators.required],
      hotelAddress: ['', Validators.required],
      hotelImage: [''],
      hotelMapLocation: ['', Validators.required],
      isActive: [true]
    });
  }

  ngOnInit(): void { this.loadHotels(); }

  loadHotels(): void {
    this.loading = true;
    this.hotelService.getHotels().subscribe({
      next: (res) => {
        if (res.success) {
          this.hotels = res.data || [];
          this.applyFilters();
        }
        this.loading = false;
      },
      error: () => { this.error = 'Failed to load hotels'; this.loading = false; }
    });
  }

  applyFilters(): void {
    let result = [...this.hotels];
    if (this.typeFilter !== 'all') result = result.filter(h => h.hotelType === this.typeFilter);
    if (this.cityFilter !== 'all') result = result.filter(h => h.hotelCity === this.cityFilter);
    if (this.searchTerm.trim()) {
      const t = this.searchTerm.toLowerCase();
      result = result.filter(h => h.hotelName.toLowerCase().includes(t));
    }
    this.filteredHotels = result;
  }
  numberOfMakkahHotels(): number {
    let hotels = this.hotels.filter(h => h.hotelCity === 'Makkah').length;
    return hotels;
  }
  numberOfMadinahHotels(): number {
    let hotels = this.hotels.filter(h => h.hotelCity === 'Madinah').length;
    return hotels;
  }
  openAddForm(): void {
    this.editMode = false;
    this.showForm = true;
    this.hotelForm.reset({ isActive: true });
  }

  openEditForm(hotel: HotelManagementProperties): void {
    this.editMode = true;
    this.showForm = true;
    this.hotelForm.patchValue(hotel);
    setTimeout(() => document.getElementById('hotelForm').scrollIntoView({ behavior: 'smooth' }), 100);
  }

  cancelForm(): void {
    this.showForm = false;
    this.editMode = false;
    this.submitted = false;
    this.hotelForm.reset({ isActive: true });
  }

  onSubmit(): void {
    this.submitted = true;
    if (this.hotelForm.invalid) return;

    this.loading = true;
    const hotel: HotelManagementProperties = this.hotelForm.value;

    const request = this.editMode
      ? this.hotelService.updateHotel(hotel.id, hotel)
      : this.hotelService.addHotel(hotel);

    request.subscribe({
      next: (res) => {
        if (res.success) {
          this.successMsg = res.message;
          this.cancelForm();
          this.loadHotels();
          this.loading = false;
          setTimeout(() => this.successMsg = null, 3000);
        } else {
          this.error = 'Operation failed: '+res.message;
          this.loading = false;
        }
      }
    });
  }

  toggleStatus(hotel: HotelManagementProperties): void {
    this.hotelService.toggleStatus(hotel.id, !hotel.isActive).subscribe({
      next: (res) => {
        if (res.success) hotel.isActive = !hotel.isActive;
        this.successMsg = res.message;
        setTimeout(() => this.successMsg = null, 2000);
      }
    });
  }
  processingAction: boolean = false;
  confirmDelete(hotel: HotelManagementProperties): void {
    this.hotelToDelete = hotel;
    this.showDeleteModal = true;
  }
  hideDeleteModal() {
    this.showDeleteModal = false;
  }
  executeDelete(): void {
    this.processingAction = true;
    if (!this.hotelToDelete) return;
    this.hotelService.deleteHotel(this.hotelToDelete.id).subscribe({
      next: (res) => {
        this.successMsg = res.message;
        this.showDeleteModal = false;
        this.hotelToDelete = null;
        this.loadHotels();
        setTimeout(() => this.successMsg = null, 3000);
        this.processingAction = false;
      }
    });
  }
  get f() { return this.hotelForm.controls; }

  getTypeBadge(type: string): string {
    return type === 'Makkah' ? 'badge bg-secondary text-light' : 'badge bg-success text-light';
  }
}
